<template>
	<div>
		<div style="border: 1px solid #ccc; border-radius: 4px; width: 100%; overflow-x: auto">
			<!-- <Toolbar
        style="border-bottom: 1px solid #ccc"
        :editor="editor"
        :defaultConfig="toolbarConfig"
        :mode="mode"
    /> -->
			<Editor ref="editorRef" style="height: 300px; overflow-y: hidden" v-model="html" :defaultConfig="editorConfig" :mode="mode" @onCreated="onCreated" @onChange="onChange" />
		</div>
		<!-- 图片放大预览弹窗 -->
		<el-dialog :visible.sync="imgPreviewVisible" width="60%" top="5vh" :append-to-body="true" custom-class="img-preview-dialog">
			<div style="text-align: center">
				<img :src="imgPreviewUrl" style="max-width: 100%; max-height: 80vh; object-fit: contain" />
			</div>
		</el-dialog>
	</div>
</template>
<style src="@wangeditor/editor/dist/css/style.css"></style>

<script>
	import Vue from 'vue';
	import { Editor, Toolbar } from '@wangeditor/editor-for-vue';
	import User from '@/utils/User.js';
	import TMessage from '@/utils/TMessage';
	import axios from 'axios';

	export default Vue.extend({
		name: 'RichEditor',
		props: {
			value: {
				type: String,
				default: ''
			},
			placeholder: {
				type: String,
				default: '请输入内容...'
			},
			height: {
				type: [String, Number],
				default: '300px'
			},
			mode: {
				type: String,
				default: 'simple' // 'default' 或 'simple'
			},
			disabled: {
				type: Boolean,
				default: false
			}
		},

		data() {
			return {
				editor: null,
				html: '',
				toolbarConfig: {},
				editContainer: null,
				imgPreviewVisible: false,
				imgPreviewUrl: '',
				editorConfig: {
					placeholder: this.placeholder,
					hoverbarKeys: {
						image: {
							menuKeys: [
                                'imageWidth30',
                                'imageWidth50',
                                'imageWidth100',
                                'deleteImage',
                            ] 
						}
					},
					MENU_CONF: {
						uploadImage: {
							// 自定义上传，与 UploadFileSingle 使用相同的接口和字段
							customUpload: async (file, insertFn) => {
								const formData = new FormData();
								formData.append('fileName', file);
								try {
									const res = await axios.post('/webL_api/third/alibaba/uploadNewImg', formData, {
										headers: {
											Authorization: 'Bearer ' + User.getToken()
										}
									});
									const data = res.data;
									if (data.code === 200) {
                                        const fileUrl = data.data.fileName;
                                        insertFn(`https://img2.teguitong.com/${fileUrl}`, file.name, fileUrl)
									} else {
										TMessage.error(data.msg || '图片上传失败');
									}
								} catch (e) {
									TMessage.error('图片上传失败，请重试');
								}
							}
						}
					}
				}
			};
		},

		components: { Editor, Toolbar },

		methods: {
			onCreated(editor) {
				this.editor = Object.seal(editor);
				if (this.disabled) {
					editor.disable();
				}
				// 点击图片放大预览
				this.$nextTick(() => {
					const container = editor.getEditableContainer();
					this.editContainer = container;
					container.addEventListener('click', this.handleImgClick);
				});
			},

			handleImgClick(e) {
				if (e.target.tagName === 'IMG') {
					this.imgPreviewUrl = e.target.src;
					this.imgPreviewVisible = true;
				}
			},

			onChange(editor) {
				this.$emit('input', this.html);
				this.$emit('change', this.html);
			},

			getHTML() {
				return this.html;
			},

			getText() {
				if (this.editor) {
					return this.editor.getText();
				}
				return '';
			},

			setHTML(html) {
				this.html = html;
			},

			clear() {
				this.html = '';
				if (this.editor) {
					this.editor.clear();
				}
			}
		},

		beforeDestroy() {
			if (this.editContainer) {
				this.editContainer.removeEventListener('click', this.handleImgClick);
			}
			const editor = this.editor;
			if (editor == null) return;
			editor.destroy();
		},

		watch: {
			value: {
				handler(nv) {
					if (nv !== this.html) {
						this.html = nv;
					}
				}
			},
			disabled(nv) {
				if (this.editor) {
					if (nv) {
						this.editor.disable();
					} else {
						this.editor.enable();
					}
				}
			}
		}
	});
</script>

<style scoped>
	::v-deep .w-e-text-container {
		min-height: 200px;
	}

	/* 长字符串（连续数字/字母）强制换行，避免横向撑宽出现横向滚动 */
	::v-deep .w-e-text-container [data-slate-editor] {
		word-break: break-all;
		overflow-wrap: break-word;
		white-space: pre-wrap;
	}

	::v-deep .w-e-text-container [data-slate-editor] p {
		word-break: break-all;
		overflow-wrap: break-word;
	}

	::v-deep .w-e-text-container img {
		cursor: pointer;
	}

    ::v-deep .w-e-text-placeholder {
		font-style: normal !important;
        top: 6px !important;
	}
</style>
